import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

/**
 * Show a toast from Laravel Inertia flash props
 * @param {Object} flash - page.props.flash object
 */
export function flashToast(flash) {
    if (!flash || !flash.message) return;

    const type = flash.status === true ? "success" : "error";

    toast(flash.message, {
        type,
        position: "top-center",
        theme: "light",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
}